import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'fern',
      d: 'M-4,-3.5h0.5v0.5h-0.5zM3.5,-3.5h0.5v1h-0.5zM-4,-3h1v0.5h-1zM2.5,-3h0.5v0.5h-0.5zM-3.5,-2.5h1v0.5h-1zM-2,-2.5h0.5v0.5h-0.5zM3,-2.5h0.5v0.5h-0.5zM-3,-2h1v0.5h-1zM-1.5,-2h0.5v0.5h-0.5zM2,-2h1v0.5h-1zM-2,-1.5h0.5v0.5h-0.5zM-1,-1.5h0.5v0.5h-0.5zM1,-1.5h1v0.5h-1zM-1.5,-1h1v0.5h-1zM0.5,-1h1.5v0.5h-1.5zM-1,-0.5h0.5v0.5h-0.5zM0.5,-0.5h0.5v0.5h-0.5zM-0.5,0h1.5v0.5h-1.5z',
    },
    {
      paint: 'leafLight',
      d: 'M-0.5,-4.5h0.5v0.5h-0.5zM-0.5,-4h1v1h-1zM-1,-3h1.5v1h-1.5zM-0.5,-2h1v0.5h-1zM-0.5,-1.5h1.5v0.5h-1.5zM-0.5,-1h1v1h-1z',
    },
    {
      paint: 'bushDark',
      d: 'M-3.5,-3.5h0.5v0.5h-0.5zM-3,-3h1v0.5h-1zM3,-3h0.5v0.5h-0.5zM-2.5,-2.5h0.5v0.5h-0.5zM2,-2.5h1v0.5h-1zM-2,-2h0.5v0.5h-0.5zM1.5,-2h0.5v0.5h-0.5zM-1.5,-1.5h0.5v0.5h-0.5z',
    },
  ],
  pixels: 59,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
